import React, { useContext, useState } from 'react';
import withAuth from '../utils/withAuth';
import { useNavigate } from 'react-router-dom';
import "../App.css"; // Assuming this is where custom styles are
import IconButton from '@mui/material/IconButton';
import RestoreIcon from '@mui/icons-material/Restore';
import { Button, TextField } from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import { Video } from 'lucide-react'; // Import for the logo icon

function HomeComponent() {
    const { addToUserHistory } = useContext(AuthContext);
    let navigate = useNavigate();

    const [meetingCode, setMeetingCode] = useState("");

    let handleJoinVideoCall = async () => {
        if (meetingCode.trim()) {
            await addToUserHistory(meetingCode.trim());
            navigate(`/${meetingCode.trim()}`);
        }
    };

    // Styling constants for the theme
    const primaryColor = '#f97316'; // Orange-500
    const darkBackground = '#0f172a'; // Slate-900

    return (
        <div style={{ minHeight: '100vh', backgroundColor: darkBackground, color: 'white' }}>
            <div className="homeNavBar"> {/* Updated class name */}
                <div style={{ display: "flex", alignItems: "center", gap: '0.5rem' }}>
                    <Video style={{ color: primaryColor, width: '1.5rem', height: '1.5rem' }} />
                    <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Connectify</h2>
                </div>
                
                <div style={{ display: "flex", alignItems: "center", gap: '1rem' }}>
                    <div className="navItem" onClick={() => navigate("/history")}>
                        <IconButton onClick={() => navigate("/history")} style={{ color: primaryColor }}>
                            <RestoreIcon />
                        </IconButton>
                        <p className="navText">History</p>
                    </div>

                    <Button
                        variant="contained"
                        onClick={() => {
                            localStorage.removeItem("token");
                            navigate("/auth");
                        }}
                        sx={{
                            backgroundColor: primaryColor,
                            '&:hover': {
                                backgroundColor: '#ea580c', // Darker orange
                            },
                        }}
                    >
                        LogOut
                    </Button>
                </div>
            </div>

            <div className="homeMeetContainer"> {/* Updated class name */}
                <div className="homeLeftPanel"> {/* Updated class name */}
                    <div>
                        <h2 className="homeHeadline">
                            Providing <span style={{ color: primaryColor }}>Quality Video Calls</span> for everyone.
                        </h2>
                        
                        <div style={{ display: "flex", gap: "10px", marginTop: '2rem' }}>
                            {/* TextField styled for the dark theme */}
                            <TextField
                                onChange={e => setMeetingCode(e.target.value)}
                                id="meeting-code"
                                label="Enter Meeting Code"
                                variant="outlined"
                                value={meetingCode}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        color: 'white',
                                        '& fieldset': { borderColor: primaryColor },
                                        '&:hover fieldset': { borderColor: primaryColor },
                                        '&.Mui-focused fieldset': { borderColor: primaryColor, borderWidth: '2px' },
                                    },
                                    '& .MuiInputLabel-root': { color: '#a0aec0' }, // Light gray label
                                    '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
                                    width: '250px',
                                }}
                            />
                            
                            <Button 
                                onClick={handleJoinVideoCall} 
                                variant='contained' 
                                disabled={!meetingCode.trim()}
                                sx={{
                                    backgroundColor: primaryColor,
                                    '&:hover': {
                                        backgroundColor: '#ea580c', // Darker orange
                                    },
                                    height: '56px', // Match TextField height
                                    fontWeight: 'bold'
                                }}
                            >
                                Join
                            </Button>
                        </div>
                    </div>
                </div>
                
                <div className="homeRightPanel"> {/* Updated class name */}
                    {/* Assuming logo3.png is a themed image or a placeholder */}
                    <img srcSet="/logo3.png" alt="Video Call Illustration" className="homeImage" />
                </div>
            </div>
        </div>
    );
}
export default withAuth(HomeComponent);